var locale = {
  placeholder: 'Chọn thời gian'
};
export default locale;
//# sourceMappingURL=vi_VN.js.map
